import React from "react";

const ErrorIcon = ({ width, height, fill, style, onClick }) => {
  return (
    // <svg
    //   width={width}
    //   height={height}
    //   viewBox="0 0 26 25"
    //   fill="none"
    //   style={style}
    //   onClick={onClick}
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M11.7734 18.75H13.6484V11.25H11.7734V18.75ZM12.6166 8.9375C12.9087 8.9375 13.1536 8.84167 13.3516 8.65C13.5495 8.45833 13.6484 8.22083 13.6484 7.9375C13.6484 7.63646 13.5497 7.38412 13.3521 7.18047C13.1546 6.97682 12.9098 6.875 12.6178 6.875C12.3257 6.875 12.0807 6.97682 11.8828 7.18047C11.6849 7.38412 11.5859 7.63646 11.5859 7.9375C11.5859 8.22083 11.6847 8.45833 11.8822 8.65C12.0798 8.84167 12.3246 8.9375 12.6166 8.9375ZM12.6255 25C10.9019 25 9.28208 24.6719 7.76612 24.0156C6.25017 23.3594 4.92448 22.4635 3.78906 21.3281C2.65365 20.1927 1.75781 18.8662 1.10156 17.3487C0.445312 15.8312 0.117188 14.2098 0.117188 12.4844C0.117188 10.759 0.445312 9.13753 1.10156 7.62003C1.75781 6.10251 2.65365 4.78125 3.78906 3.65625C4.92448 2.53125 6.25095 1.64062 7.76847 0.984375C9.28597 0.328125 10.9074 0 12.6328 0C14.3582 0 15.9797 0.328125 17.4972 0.984375C19.0147 1.64062 20.3359 2.53125 21.4609 3.65625C22.5859 4.78125 23.4766 6.10417 24.1328 7.625C24.7891 9.14583 25.1172 10.7681 25.1172 12.4917C25.1172 14.2153 24.7891 15.8351 24.1328 17.3511C23.4766 18.867 22.5859 20.1908 21.4609 21.3224C20.3359 22.454 19.013 23.3498 17.4922 24.0099C15.9714 24.67 14.3491 25 12.6255 25ZM12.6328 23.125C15.5807 23.125 18.0859 22.0885 20.1484 20.0156C22.2109 17.9427 23.2422 15.4323 23.2422 12.4844C23.2422 9.53646 22.2129 7.03125 20.1543 4.96875C18.0957 2.90625 15.5833 1.875 12.6172 1.875C9.67969 1.875 7.17448 2.90429 5.10156 4.96288C3.02865 7.02148 1.99219 9.53385 1.99219 12.5C1.99219 15.4375 3.02865 17.9427 5.10156 20.0156C7.17448 22.0885 9.6849 23.125 12.6328 23.125Z"
    //     fill={fill}
    //   />
    // </svg>
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M53.079 20.474V11.6767C54.2263 11.011 55.1221 9.98561 55.6277 8.7593C56.1334 7.53298 56.2206 6.17417 55.8759 4.89328C55.5312 3.61239 54.7738 2.48087 53.721 1.67394C52.6682 0.867011 51.3787 0.429688 50.0523 0.429688C48.7258 0.429688 47.4363 0.867011 46.3836 1.67394C45.3308 2.48087 44.5734 3.61239 44.2287 4.89328C43.884 6.17417 43.9712 7.53298 44.4768 8.7593C44.9824 9.98561 45.8783 11.011 47.0256 11.6767V20.474"
        fill="#00678F"
      />
      <path
        d="M15.9766 81.1503L19.3144 97.636L36.6204 88.4597L30.9178 77.2637L15.9766 81.1503Z"
        fill="#FFA300"
      />
      <path
        d="M0.101833 47.5957L0 57.3717C0.101833 75.7865 22.4486 90.6938 50.0001 90.6938C77.5516 90.6938 99.8927 75.7865 99.9945 57.3717V47.5957"
        fill="#FFA300"
      />
      <path
        d="M50.0507 81.8794C77.6369 81.8794 99.9999 66.9049 99.9999 48.4329C99.9999 29.9609 77.6369 14.9863 50.0507 14.9863C22.4646 14.9863 0.101562 29.9609 0.101562 48.4329C0.101562 66.9049 22.4646 81.8794 50.0507 81.8794Z"
        fill="#FFCC00"
      />
      <path
        d="M16.9102 73.53L20.248 90.0156L37.554 80.8393L28.4003 73.1113H16.9102"
        fill="#FFCC00"
      />
      <path
        d="M57.3264 57.179C57.3264 55.114 54.0338 53.4395 49.9718 53.4395C45.9098 53.4395 42.6172 55.1367 42.6172 57.179V57.7447C42.6172 58.6952 45.9098 59.442 49.9718 59.442C54.0338 59.442 57.3264 58.6725 57.3264 57.7447"
        fill="#00678F"
      />
      <path
        d="M22.1429 68.8731C21.2971 68.0278 20.7276 66.9459 20.5094 65.7702C20.2912 64.5945 20.4347 63.3803 20.9209 62.2879L24.27 54.7692C24.4521 54.3789 24.7418 54.0486 25.1051 53.8172C25.4684 53.5858 25.8901 53.4629 26.3209 53.4629C26.7516 53.4629 27.1733 53.5858 27.5366 53.8172C27.8999 54.0486 28.1896 54.3789 28.3717 54.7692L31.7265 62.2879C32.2127 63.3803 32.3561 64.5945 32.138 65.7702C31.9198 66.9459 31.3502 68.0278 30.5045 68.8731C29.9559 69.4229 29.3042 69.859 28.5868 70.1566C27.8694 70.4542 27.1004 70.6074 26.3237 70.6074C25.547 70.6074 24.7779 70.4542 24.0605 70.1566C23.3431 69.859 22.6915 69.4229 22.1429 68.8731Z"
        fill="white"
      />
      <path
        d="M32.2763 48.4914C32.81 45.2037 30.5774 42.1059 27.2897 41.5723C24.0021 41.0386 20.9042 43.2712 20.3706 46.5588C19.8369 49.8465 22.0695 52.9443 25.3572 53.478C28.6448 54.0117 31.7427 51.7791 32.2763 48.4914Z"
        fill="#00678F"
      />
      <path
        d="M80.1084 48.4875C80.642 45.1998 78.4095 42.102 75.1218 41.5684C71.8341 41.0347 68.7363 43.2673 68.2026 46.5549C67.669 49.8426 69.9015 52.9404 73.1892 53.4741C76.4769 54.0078 79.5747 51.7752 80.1084 48.4875Z"
        fill="#00678F"
      />
      <path
        d="M32.2744 44.2883C32.808 41.0006 30.5755 37.9028 27.2878 37.3691C24.0001 36.8355 20.9023 39.068 20.3686 42.3557C19.835 45.6434 22.0675 48.7412 25.3552 49.2749C28.6429 49.8085 31.7407 47.576 32.2744 44.2883Z"
        fill="#FFCC00"
      />
      <path
        d="M80.1064 44.2883C80.6401 41.0006 78.4075 37.9028 75.1198 37.3691C71.8321 36.8355 68.7343 39.068 68.2007 42.3557C67.667 45.6434 69.8996 48.7412 73.1872 49.2749C76.4749 49.8085 79.5727 47.576 80.1064 44.2883Z"
        fill="#FFCC00"
      />
    </svg>
  );
};

ErrorIcon.defaultProps = {
  width: 100,
  height: 98,
  fill: "black",
};

export default ErrorIcon;
